export const searchCodeCond = {
  PROGRESS_10: {
    SEARCH_CODE: 'PROGRESS_10',
    TEXT: 'ความก้าวหน้าผลการดำเนินการ 10%',
  },
  PROGRESS_20: {
    SEARCH_CODE: 'PROGRESS_20',
    TEXT: 'ความก้าวหน้าผลการดำเนินการ 20%',
  },
  PROGRESS_40: {
    SEARCH_CODE: 'PROGRESS_40',
    TEXT: 'ความก้าวหน้าผลการดำเนินการ 40%',
  },
  PROGRESS_60: {
    SEARCH_CODE: 'PROGRESS_60',
    TEXT: 'ความก้าวหน้าผลการดำเนินการ 60%',
  },
  PROGRESS_80: {
    SEARCH_CODE: 'PROGRESS_80',
    TEXT: 'ความก้าวหน้าผลการดำเนินการ 80%',
  },
  PROGRESS_100: {
    SEARCH_CODE: 'PROGRESS_100',
    TEXT: 'ความก้าวหน้าผลการดำเนินการ 100%',
  },
  INDICATORS_001: {
    SEARCH_CODE: 'INDICATORS_001',
    TEXT: 'โครงการตัวอย่างดี',
  },
  INDICATORS_002: {
    SEARCH_CODE: 'INDICATORS_002',
    TEXT: 'จำนวนแกนนำ',
  },
  INDICATORS_003: {
    SEARCH_CODE: 'INDICATORS_003',
    TEXT: 'จำนวนกลุ่มเป้าหมายเข้าร่วมโครงการ',
  },
  INDICATORS_004: {
    SEARCH_CODE: 'INDICATORS_004',
    TEXT: 'จำนวนกลุ่มเป้าหมายปรับพฤติกรรม',
  },
  INDICATORS_005: {
    SEARCH_CODE: 'INDICATORS_005',
    TEXT: 'ทางตรง',
  },
  INDICATORS_006: {
    SEARCH_CODE: 'INDICATORS_006',
    TEXT: 'ทางอ้อม',
  },
  INDICATORS_007: {
    SEARCH_CODE: 'INDICATORS_007',
    TEXT: 'โครงการที่เกิดสภาพแวดล้อมหรือปัจจัยทางสังคมที่เอื้อต่อสุขภาวะ',
  },
  INDICATORS_008: {
    SEARCH_CODE: 'INDICATORS_008',
    TEXT: 'กฏ กติกา มาตรการชุมชน',
  },
  INDICATORS_009: {
    SEARCH_CODE: 'INDICATORS_009',
    TEXT: 'กลไก ระบบ โครงสร้าง',
  },
  INDICATORS_010: {
    SEARCH_CODE: 'INDICATORS_010',
    TEXT: 'นวัตกรรมฯ ระดับพื้นที่',
  },
  INDICATORS_011: {
    SEARCH_CODE: 'INDICATORS_011',
    TEXT: 'พัฒนาความรู้ใหม่จากวิจัยพัฒนา',
  },
  INDICATORS_012: {
    SEARCH_CODE: 'INDICATORS_012',
    TEXT: 'นำสิ่งที่มีอยู่ในชุมชนอื่นมาปรับใช้ในชุมชนตนเอง',
  },
  RISK_3: {
    SEARCH_CODE: 'RISK_3',
    TEXT: 'ความเสี่ยงสูง',
  },
  RISK_2: {
    SEARCH_CODE: 'RISK_2',
    TEXT: 'ความเสี่ยงปานกลาง',
  },
  RISK_1: {
    SEARCH_CODE: 'RISK_1',
    TEXT: 'ความเสี่ยงต่ำ',
  },
  RISK_0: {
    SEARCH_CODE: 'RISK_0',
    TEXT: 'ไม่มีความเสี่ยง',
  },
}
